import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { SparePartTeaserCard } from '@/components/home/SparePartTeaserCard';
import { SectionHeading } from '@/components/home/helpers';
import { ArrowRight, Wrench } from 'lucide-react';

export const SparePartTeaserSection = ({ spareParts, loading }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section
      className="bg-slate-50 dark:bg-slate-900/50 border-b border-slate-200 dark:border-slate-800"
      data-testid="spare-part-teaser-strip"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14">
        <SectionHeading
          label={t('home.spareParts.label')}
          title={t('home.spareParts.title')}
          subtitle={t('home.spareParts.subtitle')}
          accentColor="#334155"
          testId="spare-parts-heading"
          cta={
            <Button
              variant="outline"
              onClick={() => navigate('/listings?vertical=spare_parts')}
              data-testid="see-all-spare-parts-btn"
              className="rounded-none border-slate-900 dark:border-slate-100 text-slate-900 dark:text-slate-100 hover:bg-slate-900 dark:hover:bg-slate-100 hover:text-white dark:hover:text-slate-900 gap-2"
            >
              {t('home.spareParts.seeAll')}
              <ArrowRight className="h-4 w-4" />
            </Button>
          }
        />
        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {[...Array(4)].map((_, i) => (
              <Skeleton key={i} className="h-28 rounded-none" />
            ))}
          </div>
        ) : spareParts.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {spareParts.map((p) => (
              <SparePartTeaserCard key={p.listing_id} listing={p} />
            ))}
          </div>
        ) : (
          <div className="border border-dashed border-slate-300 dark:border-slate-700 p-10 text-center bg-white dark:bg-slate-900">
            <Wrench className="h-10 w-10 mx-auto text-slate-300 dark:text-slate-600 mb-3" />
            <p className="text-sm text-slate-600 dark:text-slate-400">
              {t('home.spareParts.emptyDesc')}{' '}
              <button
                className="text-slate-900 dark:text-slate-100 font-semibold underline underline-offset-2"
                onClick={() => navigate('/listing/new?vertical=spare_parts')}
                data-testid="empty-spare-create-btn"
              >
                {t('home.spareParts.emptyCreate')}
              </button>
            </p>
          </div>
        )}
      </div>
    </section>
  );
};
